import SelectInput from '../SelectInput/SelectInput';
import { ButtonContinue } from '../Button/ButtonContinue';
import { Claim, ClaimError, SelectOpt } from '../CommonTypes';
import SimpleDateInput from '../DateInput/SimpleDateInput';

interface ClaimProps {
  claims: Claim[];
  errors?: ClaimError[];
  claimTypes: SelectOpt[];
  onUpdateClaims: (claims: Claim[]) => void;
}

const Claims = ({ claims, claimTypes, errors, onUpdateClaims }: ClaimProps) => {
  if (claims.length === 0)
    claims = [...claims, { claimType: '', claimDate: undefined }];

  const onChangeClaimDateValue = (date: Date | null, index: number): void => {
    const updatedClaims = claims.map((c, i) =>
      i === index
        ? {
            ...c,
            claimDate: date === null ? undefined : date
          }
        : { ...c }
    );
    onUpdateClaims(updatedClaims);
  };

  const onClickAddAnotherClaim = (): void => {
    const newClaims = [...claims, { claimType: '', claimDate: undefined }];
    onUpdateClaims(newClaims);
  };

  const onClickRemoveClaim = (index: number): void =>
    onUpdateClaims(claims.filter((c, i) => index !== i));

  const onChangeClaimType = (value: string, index: number) => {
    const updatedClaims = claims.map((c, i) =>
      i === index ? { ...c, claimType: value } : { ...c }
    );
    onUpdateClaims(updatedClaims);
  };

  return (
    <div className='add-new-claim'>
      {claims.map((claim, index) => (
        <div key={`claim-${index}`}>
          <div className='flex-row'>
            <div className='inline-control'>
              <div className='control-label'>Type of claim</div>
              <div className='control'>
                <SelectInput
                  name={`type-of-claim-${index}`}
                  className='input-text w250'
                  value={claim.claimType}
                  onChange={(value: string) => {
                    onChangeClaimType(value, index);
                  }}
                  options={claimTypes}
                  defaultText='Select...'
                  forceDefault
                  addDefaultOption
                  loadingText='Loading...'
                  error={errors?.at(index)?.claimType ?? ''}
                />
              </div>
            </div>
            <div className='inline-control'>
              <div className='control-label'>Claim Date</div>
              <div className='control'>
                <SimpleDateInput
                  name={`claim-date-${index}`}
                  value={claim.claimDate}
                  error={errors?.at(index)?.claimDate ?? ''}
                  onDateChange={(date) => onChangeClaimDateValue(date, index)}
                  maximumDate={new Date()}
                />
              </div>
            </div>
            {index > 0 && (
              <div className='inline-control remove-button-wrapper'>
                <ButtonContinue
                  name={`remove-claim-line-${index}`}
                  text='Remove'
                  onClick={() => onClickRemoveClaim(index)}
                  additionalClassNames='btn-cancel'
                />
              </div>
            )}
          </div>
          {claims.length - 1 === index && claims.length < 9 && (
            <div>
              <ButtonContinue
                name={`add-another-claim-${index}`}
                text='Add another claim'
                onClick={onClickAddAnotherClaim}
                additionalClassNames='btn-ok'
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Claims;
